import script from "./UiTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./UiTooltip.vue?vue&type=style&index=0&id=2aec9d11&lang=sass&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aec9d11"]])

export default __exports__